import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import BackButton from '../../../../components/UI/BackButton';
import { Button, Collapsible, Input, InfiniteScroll, Title, Fab } from '../../../../components/UI/ComponentsUI';
import { closeCollapsible, formatData, translate } from '../../../../utils/util';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import PduLocationTargetService from '../../../../services/PduLocationTargetService';
import ModalUploadPduLocation from './ModalUploadPduLocation';

const PduLocationTargetList = (props) => {
    const [data, setData] = useState([]);
    const [selectAll, setSelectAll] = useState(false)
    const [refresh, setRefresh] = useState(0);
    const [selectedItems, setSelectedItems] = useState([])
    const [openModal, setOpenModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [filter, setFilter] = useState({
        pdu: '',
        locationTarget: ''
    })

    useEffect(() => {
        if (props.pduLocationTargetPaged?.items?.length > 0) {
            if (data.length > 0 && currentPage === 0) {
                setData(props.pduLocationTargetPaged.items);
            } else {
                setData((prevState) => ([...prevState, ...props.pduLocationTargetPaged.items]));
            }
        } else {
            setData([]);
        }
        // eslint-disable-next-line
    }, [props.pduLocationTargetPaged?.items]);

    useEffect(() => {
        onSearch();
        // eslint-disable-next-line
    }, [currentPage, refresh]);

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onSelectItemChange = (item) => {
        props.setPduLocationTarget(item);
        props.history.push({ pathname: '../pdulocationtarget/insert', state: { update: true } });
    };

    const onSearch = () => {
        const filterObj = {};
        Object.assign(filterObj, filter);
        filterObj.PageSize = 20;
        filterObj.PageIndex = currentPage;
        setFilter(filterObj);

        props.getPaged(filterObj, () => {
            setSelectedItems([]);
            closeCollapsible('filterPduLocationTarget')
        });
    }

    const refreshComponent = () => {
        setCurrentPage(0);
        setRefresh(refresh + 1);
    }

    const onDelete = (item) => {
        props.delete(item.id, () => {
            refreshComponent()
        });
    }


    const onDeleteList = () => {
        var listIds = selectedItems.map((f) => { return f.id });
        props.deleteList(listIds, () => {
            refreshComponent()
        });

    }

    const addSelectedItem = (item) => {
        if (selectedItems.some(e => e.id === item.id)) {
            removeSelected(item)
        } else {
            let list = [];
            Object.assign(list, selectedItems);
            list.push(item)
            setSelectedItems(list);
        }
    }

    const removeSelected = (item) => {
        let list = [];
        Object.assign(list, selectedItems);
        let index = list.findIndex(x => x.id === item.id)
        list.splice(index, 1);
        setSelectedItems(list)
    }

    const onClickSelectAll = () => {
        if (selectAll) {
            setSelectAll(false)
            setSelectedItems([])
        } else {
            setSelectAll(true)
            setSelectedItems(data)
        }
    }

    return (
        <div>
            <BackButton {...props} />
            <Title icon="mdi mdi-clipboard-list-outline" label={"PDU x Destino"} />
            <i className={`mdi mdi-cloud-upload above-btn`} style={{ cursor: 'pointer' }} onClick={() => setOpenModal(true)} />
            <div className="container-fluid" style={{ marginTop: '5px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="filterPduLocationTarget"
                        header={translate('filter', 'physical-confirmation')}
                        body={
                            <div id="formInput" className="form-group">
                                <div className="row">
                                    <div className="col s6 no-padding">
                                        <div className="input-field">
                                            <Input
                                                id="pdu"
                                                name="pdu"
                                                label="PDU"
                                                type="text"
                                                defaultValue={filter.pdu || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col s6 no-padding">
                                        <div className="input-field">
                                            <Input
                                                id="locationTarget"
                                                name="locationTarget"
                                                label="Destino"
                                                type="text"
                                                defaultValue={filter.locationTarget || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    />
                    <div className="row">
                        <div className="col s12 left">
                            <Button
                                full="true"
                                className="col s6 btn-principal"
                                text="Buscar"
                                onClick={() => {
                                    refreshComponent();
                                }}
                            />
                        </div>

                    </div>
                </div>
                {data.length > 0 &&
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div className='flex-center' >
                            <b className="sixth-text-color">{translate('SelectAll', 'general')}</b>
                            <span className="title sixth-text-color" >
                                <i
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => onClickSelectAll()}
                                    className={`mdi mdi-checkbox-multiple-marked ${selectAll ? 'green' : 'gray'}-text`}
                                />
                            </span>
                        </div>
                    </div>
                }
                <InfiniteScroll
                    page={props.pduLocationTargets?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    data={data.map((item, index) => {
                        return (
                            <div
                                style={{ display: 'block', padding: '10px', height: 'auto' }}
                                key={`oi-${index}`}
                            >
                                <span className="title sixth-text-color right" style={{ marginTop: '0px' }}>
                                    <i
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => addSelectedItem(item)}
                                        className={`mdi mdi-checkbox${selectedItems.some(e => e.id === item.id) ? '-marked green' : '-blank-outline gray'}-text`}
                                    />
                                </span>
                                <span className="title sixth-text-color right">
                                    <i style={{ cursor: 'pointer' }} onClick={() => onDelete(item)} className="mdi mdi-delete"></i>
                                </span>
                                <div onClick={() => onSelectItemChange(item)}>
                                    <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                        <i className="mdi mdi-map-marker-check" />PDU: {item.pdu}
                                    </span>
                                    <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                        <i className="mdi mdi-map-marker-path" />Destino: {item.locationTarget}
                                    </span>
                                    <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                        <i className="mdi mdi-map-marker-path" />{item.updatedBy} - {formatData(item.updatedOn)}
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                />
            </div>
            <ModalUploadPduLocation
                open={openModal}
                id="ModalUploadPduLocation"
                onCancel={() => setOpenModal(false)}
                onClose={() => setOpenModal(false)}
                onConfirm={() => setCurrentPage(0)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
            {data.length > 0 &&
                <Fab
                    buttons={[
                        { label: translate('change-location:top'), icon: <i className="mdi mdi-publish" />, color: 'darkgreen', onClick: () => { window.scrollTo(0, 0) } },
                        { label: translate('SelectAll', 'general'), icon: <i className="mdi mdi-delete-forever" />, onClick: () => onClickSelectAll() },
                        { label: translate('change-location:delete-selected'), color: 'darkred', icon: <i className="mdi mdi-delete" />, onClick: () => onDeleteList() }
                    ]}
                />
            }
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        pduLocationTargetPaged: state.linePickingReducer.pduLocationTargetPaged
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPaged: (filter, callback) => {
            dispatch(PduLocationTargetService.getPaged(filter, callback));
        },
        setPduLocationTarget: (item) => {
            dispatch(PduLocationTargetService.setPduLocationTarget(item));
        },
        delete: (id, callback) => {
            dispatch(PduLocationTargetService.delete(id, callback));
        },
        deleteList: (list, callback) => {
            dispatch(PduLocationTargetService.deleteList(list, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PduLocationTargetList));
